import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from './ui/button';

const MobileBackButton = ({ className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Don't show on root pages
  const rootPaths = ['/', '/login', '/dashboard', '/admin'];
  const isRootPath = rootPaths.includes(location.pathname) || location.pathname === '/admin';
  
  // Don't show on public pages without history
  const isPublicPage = location.pathname.startsWith('/survey') || 
                       location.pathname.startsWith('/s/');
  
  if (isRootPath || isPublicPage) {
    return null;
  }
  
  const handleBack = () => {
    // Check if there's history to go back to
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      // Default fallback based on path
      if (location.pathname.startsWith('/admin')) {
        navigate('/admin');
      } else if (location.pathname.startsWith('/prep')) {
        // Don't navigate away from prep page, it's token-protected
        return;
      } else {
        navigate('/dashboard');
      }
    }
  };
  
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleBack}
      className={`md:hidden flex items-center gap-1 text-slate-600 hover:text-slate-900 -ml-2 ${className}`}
      data-testid="mobile-back-btn"
    >
      <ChevronLeft className="h-5 w-5" />
      <span className="text-sm">Tilbage</span>
    </Button>
  );
};

export default MobileBackButton;
